import React, { useContext, useEffect, useRef } from 'react'
import { QuestionDetailsCallbackMap } from 'tabs/topQuestions/components/top_questions_content/TopQuestionsPageContent'
import { QuestionsDetailsWebsocketContext } from 'tabs/topQuestions/components/questions_websocket_connector/QuestionsDetailsWebsocketConnector'
import { TopQuestionsLineChartInitializer } from 'tabs/topQuestions/components/top_questions_historical_data_initializer/TopQuestionsLineChartInitializer'
import { TopQuestionsListInitializer } from 'tabs/topQuestions/components/top_questions_list_initializer/TopQuestionsListInitializer'
import { useDispatch, useSelector } from 'react-redux'
import { selectIsClustering } from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusSelectors'
import { checkIfClustering } from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusApi'
import { ClusteringStatus } from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusTypes'


type TopQuestionsDataContentProps = {
  botId: number
  questionDetailsCallback: QuestionDetailsCallbackMap
  clusteringExecutionId: string | undefined
}

export const TopQuestionsDataContent: React.FC<TopQuestionsDataContentProps> = ({
                                                                                  botId,
                                                                                  clusteringExecutionId,
                                                                                  questionDetailsCallback,
                                                                                }) => {
  const dispatch = useDispatch()
  const isClusterCheckTimeoutRef = useRef<ReturnType<typeof setTimeout>>()
  const clusteringCheckStatus = useSelector(selectIsClustering(clusteringExecutionId)) || { status: ClusteringStatus.NEW, n: 0 }

  const isTraining = clusteringCheckStatus?.status === 'PENDING'

  console.log('Check status: ' + JSON.stringify(clusteringCheckStatus))
  console.log('Execution id: ' + clusteringExecutionId)

  useEffect(() => {
    if (clusteringCheckStatus.status === ClusteringStatus.PENDING) {
      const fiveSeconds = 5000
      isClusterCheckTimeoutRef.current = setTimeout(() => {
        dispatch(checkIfClustering(botId, clusteringExecutionId))
      }, fiveSeconds)
    }
  }, [clusteringCheckStatus.status, clusteringCheckStatus.n])

  const { sendFetchClusterQuestionsMessage } = useContext(QuestionsDetailsWebsocketContext)

  return <div className={'topQuestionsPage'}>
    <TopQuestionsLineChartInitializer trainingStatus={clusteringCheckStatus}
                                      executionId={clusteringExecutionId} />
    <div className={'topQuestionsControlsWrapper'}>
      <TopQuestionsListInitializer clusteringExecutionId={clusteringExecutionId}
                                   trainingStatus={clusteringCheckStatus}
                                   sendFetchClusterQuestionsMessage={sendFetchClusterQuestionsMessage} />
    </div>
  </div>

}
